/* Ürün sayfası: galeri, varyant, favori, teslim, sabit sepete ekle */
(function () {
if (window.DedeProduct) { window.DedeProduct.init(document); return; }
var mob = matchMedia('(max-width:900px)');
function fe(list, fn) { Array.prototype.forEach.call(list, fn); }
function each(s, sel, fn) { fe(s.querySelectorAll(sel), fn); }
function once(el, k) { return !el['_dd' + k] && (el['_dd' + k] = true); }
/* şeridi sayfa kaymadan hizala */
function center(st, t) {
	var a = st.getBoundingClientRect(), b = t.getBoundingClientRect();
	if (st.scrollWidth > st.clientWidth + 1) st.scrollLeft += b.left - a.left - (a.width - b.width) / 2;
	if (st.scrollHeight > st.clientHeight + 1) st.scrollTop += b.top - a.top - (a.height - b.height) / 2;
}
function on(el, ev, fn, o) { el.addEventListener(ev, fn, o); }

/* galeri: masaüstü geçiş, mobil snap */
function gallery(g) {
	if (!once(g, 'g')) return;
	var sl = g.querySelectorAll('.pp__slide'), th = g.querySelectorAll('.pp__thumb'), n = sl.length;
	var cur = g.querySelector('[data-gallery-current]'), tr = g.querySelector('[data-gallery-track]');
	var wrap = g.querySelector('.pp__slides') || g, i = 0, lock = -1, lt, raf = 0;
	fe(sl, function (s, k) { if (s.classList.contains('is-active')) i = k; });
	if (n < 2) return;
	function scr() { return mob.matches && tr && tr.scrollWidth > tr.clientWidth + 1; }
	function off(k) { return sl[k].offsetLeft - sl[0].offsetLeft; }
	function paint(k, focus) {
		i = k;
		/* aria-hidden yalnız masaüstü geçişinde: ≤900px'de slaytlar kaydırılan bir
		   şerit, hepsi GÖRÜNÜR — saklamak görüneni ekran okuyucudan gizliyordu. */
		fe(sl, function (s, j) { s.classList.toggle('is-active', j === i); if (!mob.matches && j !== i) s.setAttribute('aria-hidden', 'true'); else s.removeAttribute('aria-hidden'); });
		fe(th, function (t, j) { t.classList.toggle('is-active', j === i); if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); t.tabIndex = j === i ? 0 : -1; });
		if (cur) cur.textContent = String(i + 1);
		var t = th[i];
		if (!t) return;
		center(t.parentElement, t);
		if (focus) t.focus({ preventScroll: true });
	}
	function go(k, focus) {
		k = (k + n) % n;
		paint(k, focus);
		if (!scr()) return;
		lock = k; clearTimeout(lt);
		lt = setTimeout(function () { lock = -1; }, 900);
		tr.scrollLeft = off(k);
	}
	g._go = go;
	/* ilk durum: go() değil paint() — go() mobilde scrollLeft'i zorlar. */
	paint(i);
	fe(th, function (t, k) {
		on(t, 'click', function () { go(k); });
		on(t, 'keydown', function (e) {
			var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
			var to = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : d ? i + d : null;
			if (to !== null) { e.preventDefault(); go(to, true); }
		});
	});
	each(g, '[data-gallery-prev]', function (b) { on(b, 'click', function () { go(i - 1); }); });
	each(g, '[data-gallery-next]', function (b) { on(b, 'click', function () { go(i + 1); }); });
	if (tr) on(tr, 'scroll', function () {
		if (raf) return;
		raf = requestAnimationFrame(function () {
			raf = 0;
			if (!scr()) return;
			var x = tr.scrollLeft, k = x >= tr.scrollWidth - tr.clientWidth - 2 ? n - 1 : Math.min(n - 1, Math.round(x / (off(1) || 1)));
			if (lock > -1) { if (k !== lock) return; lock = -1; }
			if (k !== i) paint(k);
		});
	}, { passive: true });
	if (mob.addEventListener) on(mob, 'change', function () { paint(i); if (scr()) tr.scrollLeft = off(i); });
	/* masaüstü: sürükleyerek geçiş */
	var sx = null, sy, sw;
	on(wrap, 'pointerdown', function (e) { sx = scr() || e.button || e.target.closest('button, a') ? null : e.clientX; sy = e.clientY; sw = 0; });
	on(wrap, 'pointerup', function (e) {
		if (sx === null) return;
		var dx = e.clientX - sx;
		sx = null;
		if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - sy) * 1.2) { sw = 1; go(dx < 0 ? i + 1 : i - 1); }
	});
	on(wrap, 'click', function (e) { if (sw) { sw = 0; e.preventDefault(); e.stopPropagation(); } }, true);
}

/* varyant → fiyat/buton/görsel/URL */
function variant(sel) {
	if (!once(sel, 'v')) return;
	var sec = sel.closest('.pp') || document, price = document.getElementById('PpPrice'), cmp = document.getElementById('PpCompare');
	var btn = sec.querySelector('[data-add-button]'), label = sec.querySelector('[data-add-label]'), sv = sec.querySelector('[data-pp-sticky-variant]');
	var def = (btn && btn.dataset.addLabelDefault) || (label ? label.textContent : '');
	on(sel, 'change', function () {
		var o = sel.options[sel.selectedIndex];
		if (!o) return;
		var ok = o.dataset.available === 'true', g = sec.querySelector('[data-gallery]');
		if (price) price.textContent = o.dataset.price || '';
		if (cmp) { cmp.textContent = o.dataset.compare || ''; cmp.hidden = !o.dataset.compare; }
		if (btn) btn.disabled = !ok;
		if (label) label.textContent = ok ? def : 'Tükendi';
		if (sv) sv.textContent = o.textContent.replace(/\s+/g, ' ').trim();
		var s = o.dataset.media && g ? g.querySelector('.pp__slide[data-media-id="' + o.dataset.media + '"]') : null;
		if (s && g._go) g._go(parseInt(s.dataset.slide, 10) || 0);
		try { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState({}, '', u); } catch (e) {}
	});
}

function wish(btn) {
	if (!once(btn, 'w')) return;
	var id = String(btn.dataset.wishlist), key = 'dede_wishlist', list = [];
	try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
	function paint() { btn.setAttribute('aria-pressed', list.indexOf(id) > -1); }
	paint();
	on(btn, 'click', function () {
		var k = list.indexOf(id);
		k > -1 ? list.splice(k, 1) : list.push(id);
		try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
		paint();
	});
}

/* mobil sabit sepete ekle */
function sticky(bar) {
	var sec = bar.closest('.pp'), main = sec && sec.querySelector('[data-add-button]'), btn = bar.querySelector('[data-pp-sticky-add]');
	if (!once(bar, 's') || !main || !btn) return;
	var lab = bar.querySelector('[data-pp-sticky-label]'), pr = bar.querySelector('[data-pp-sticky-price]'), mp = document.getElementById('PpPrice');
	var err = sec.querySelector('[data-add-error]'), se = bar.querySelector('[data-pp-sticky-error]');
	var end = document.querySelector('main') || sec.parentNode, typing = false, raf = 0, shown = null;
	function sync() {
		var ml = main.querySelector('[data-add-label]');
		btn.disabled = main.disabled;
		btn.classList.toggle('is-loading', main.classList.contains('is-loading'));
		if (ml && lab) lab.textContent = ml.textContent;
		if (pr && mp) pr.textContent = mp.textContent;
		if (se && err) { se.textContent = err.textContent; se.hidden = err.hidden || !err.textContent; }
	}
	function update() {
		raf = 0;
		var h = innerHeight, v = mob.matches && !typing && main.getBoundingClientRect().bottom < 0 && end.getBoundingClientRect().bottom > h - 8;
		/* yalnızca rutin butonu çubuğun bandına girince gizle */
		if (v) each(document, '[data-pp-sticky-hide]', function (z) { var r = z.getBoundingClientRect(); if (r.bottom > h - 150 && r.top < h) v = false; });
		if (v === shown) return;
		shown = v;
		bar.classList.toggle('is-visible', v);
		bar.inert = !v;
		bar.setAttribute('aria-hidden', !v);
	}
	function queue() { if (!raf) raf = requestAnimationFrame(update); }
	var mo = { attributes: true, childList: true, subtree: true, characterData: true };
	[main, mp, err].forEach(function (el) { if (el) new MutationObserver(sync).observe(el, mo); });
	/* klavye açıkken gizle */
	on(document, 'focusin', function (e) {
		typing = !!(e.target.matches && e.target.matches('input:not([type=checkbox]):not([type=radio]), textarea, select, [contenteditable]'));
		queue();
	});
	on(document, 'focusout', function () { typing = false; setTimeout(queue, 60); });
	on(window, 'scroll', queue, { passive: true });
	on(window, 'resize', queue);
	sync();
	update();
}

/* teslim tarihi */
function eta(el) {
	function g(a) { return parseInt(el.getAttribute('data-' + a), 10) || 0; }
	var min = g('min'), max = g('max'), cut = g('cutoff'), skip = el.getAttribute('data-weekends') === 'skip', lang = document.documentElement.lang || 'tr';
	/* kesim ve iş günü takvimi MAĞAZA saatine sabit (ziyaretçinin saatiyle tarih
	   kayıyordu). Sayfa CDN'den önbellekli geldiği için damga değil yalnız OFSET
	   gömülür; TR yaz saati uygulamadığı için +03.00 sabit, yoksa 180. */
	var tzm = /^([+-])(\d{2}):?(\d{2})$/.exec(el.getAttribute('data-tzoffset') || ''),
		off = tzm ? (tzm[1] === '-' ? -1 : 1) * (+tzm[2] * 60 + +tzm[3]) : 180,
		shop = new Date(Date.now() + off * 60000),
		now = new Date(shop.getUTCFullYear(), shop.getUTCMonth(), shop.getUTCDate(), shop.getUTCHours());
	if (cut && now.getHours() >= cut) now.setDate(now.getDate() + 1);
	function add(n) {
		var d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		function we() { return skip && d.getDay() % 6 === 0; }
		while (we()) d.setDate(d.getDate() + 1);
		while (n > 0) { d.setDate(d.getDate() + 1); if (!we()) n--; }
		return d;
	}
	function f(d, m) { return d.toLocaleDateString(lang, m ? { day: 'numeric', month: 'long' } : { day: 'numeric' }); }
	var a = add(min), b = add(max);
	try { el.textContent = +a === +b ? f(a, 1) : (a.getMonth() === b.getMonth() && /^tr/i.test(lang) ? f(a) : f(a, 1)) + ' – ' + f(b, 1); } catch (e) {}
}

function init(scope) {
	scope = scope && scope.querySelectorAll ? scope : document;
	each(scope, '[data-eta]', eta);
	each(scope, '[data-gallery]', gallery);
	each(scope, '[data-variant-select]', variant);
	each(scope, '[data-wishlist]', wish);
	each(scope, '[data-pp-sticky]', sticky);
	/* boş <p><br></p> boşluk bırakmasın */
	each(scope, '.pp-tabs__body p, .pp-acc__text p', function (p) { if (!p.textContent.trim() && !p.querySelector('img,svg,iframe,video')) p.hidden = true; });
}
window.DedeProduct = { init: init };
init(document);
on(document, 'shopify:section:load', function (e) { init(e.target); });
on(document, 'shopify:block:select', function (e) {
	var acc = e.target && e.target.closest ? e.target.closest('[data-pp-acc]') : null;
	if (acc && !acc.open) acc.open = true;
});
/* adet −/+, mobil sekme hapı, devamını oku */
on(document, 'click', function (e) {
	var t = e.target.closest && e.target.closest('.pp-tabs__tab, [data-qty] button, [data-pp-more]'), q, p;
	if (!t) return;
	if (t.hasAttribute('data-pp-more')) {
		q = t.getAttribute('aria-expanded') !== 'true'; p = t.parentNode;
		t.setAttribute('aria-expanded', q); p.classList.toggle('is-open', q);
		if (!q && (p = p.getBoundingClientRect().top) < 0) scrollBy(0, p - 90);
		return;
	}
	if (!t.closest('[data-qty]')) return center(t.parentElement, t);
	q = t.parentElement.querySelector('input');
	if (q) q.value = Math.max(1, (+q.value || 1) + (t.hasAttribute('data-qty-plus') ? 1 : -1));
});
})();
